module.exports = __webpack_public_path__ + "img/kort-16.d39f75d6.jpg";